'use strict';
gsap.registerPlugin(ScrollTrigger);

/* ── LENIS */
const lenis = new Lenis({ lerp: 0.075, smoothWheel: true });
lenis.on('scroll', ScrollTrigger.update);
gsap.ticker.add((t) => lenis.raf(t * 1000));
gsap.ticker.lagSmoothing(0);

/* ── DRAWER */
const $drawer   = document.getElementById('drawer');
const $drawerBg = document.getElementById('drawer-bg');
const $burger   = document.getElementById('hdr-burger');
function openDr() {
  $drawer.hidden = false;
  requestAnimationFrame(() => { $drawer.classList.add('open'); $drawerBg.classList.add('show'); });
  $burger.setAttribute('aria-expanded', 'true');
  lenis.stop();
}
function closeDr() {
  $drawer.classList.remove('open'); $drawerBg.classList.remove('show');
  $burger.setAttribute('aria-expanded', 'false');
  $drawer.addEventListener('transitionend', () => { $drawer.hidden = true; }, { once: true });
  lenis.start();
}

/* ── BOOT */
function boot() {
  initCursor();
  initScrollProgress();
  initHeader();
  if (document.querySelector('.hero-first-img')) heroEntrance();
  initHeroMouseParallax();
  initTextReveals();
  initImgReveals();
  initWishlistBtn();
  initParallax();
  initMagnetic();
  initCarousel();
  initSearch();
}

/* ── PRODUCTS CAROUSEL */
function initCarousel() {
  const track = document.getElementById('prod-track');
  if (!track) return;

  const CARD_W = 330;
  const SET_LEN = track.querySelectorAll('.card:not([aria-hidden])').length;
  const LOOP_W = CARD_W * SET_LEN;
  const SPEED = 0.55;

  let pos = 0;
  let paused = false;
  let animating = false;

  gsap.set(track, { x: 0 });

  function tick() {
    if (!paused && !animating) {
      pos -= SPEED;
      if (pos <= -LOOP_W) pos += LOOP_W;
      gsap.set(track, { x: pos });
    }
    requestAnimationFrame(tick);
  }
  tick();

  function stepPrev() {
    if (animating) return;
    animating = true;
    pos += CARD_W;
    if (pos > 0) pos -= LOOP_W;
    gsap.to(track, { x: pos, duration: 0.55, ease: 'power2.inOut', onComplete: () => { animating = false; } });
  }
  function stepNext() {
    if (animating) return;
    animating = true;
    pos -= CARD_W;
    if (pos <= -LOOP_W) pos += LOOP_W;
    gsap.to(track, { x: pos, duration: 0.55, ease: 'power2.inOut', onComplete: () => { animating = false; } });
  }

  track.addEventListener('mouseenter', () => { paused = true; });
  track.addEventListener('mouseleave', () => { paused = false; });
  document.getElementById('prod-prev')?.addEventListener('click', stepPrev);
  document.getElementById('prod-next')?.addEventListener('click', stepNext);

  let touchStartX = 0;
  track.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; paused = true; }, { passive: true });
  track.addEventListener('touchend', e => {
    const dx = e.changedTouches[0].clientX - touchStartX;
    paused = false;
    if (Math.abs(dx) < 40) return;
    if (dx > 0) stepPrev(); else stepNext();
  }, { passive: true });
}

/* ── CUSTOM CURSOR */
function initCursor() {
  const cr = document.getElementById('cr');
  const cd = document.getElementById('cd');
  if (!cr || !cd || window.matchMedia('(hover: none)').matches) return;

  let mx = window.innerWidth / 2, my = window.innerHeight / 2;
  let dx = mx, dy = my;

  gsap.set([cr, cd], { xPercent: -50, yPercent: -50 });

  window.addEventListener('mousemove', e => {
    mx = e.clientX; my = e.clientY;
    gsap.set(cr, { x: mx, y: my });
  });

  function trackDot() {
    dx += (mx - dx) * 0.1;
    dy += (my - dy) * 0.1;
    gsap.set(cd, { x: dx, y: dy });
    requestAnimationFrame(trackDot);
  }
  trackDot();

  const hoverEls = document.querySelectorAll('a, button, .card, .ig-cell');
  hoverEls.forEach(el => {
    el.addEventListener('mouseenter', () => document.body.classList.add('c-hover'));
    el.addEventListener('mouseleave', () => document.body.classList.remove('c-hover'));
  });

  const darkZones = ['#hero', '#hero2', '#marquee', '#ann', '#foot'];
  darkZones.forEach(sel => {
    const el = document.querySelector(sel);
    if (!el) return;
    ScrollTrigger.create({
      trigger: el, start: 'top 50%', end: 'bottom 50%',
      onEnter:     () => document.body.classList.add('c-dark'),
      onLeave:     () => document.body.classList.remove('c-dark'),
      onEnterBack: () => document.body.classList.add('c-dark'),
      onLeaveBack: () => document.body.classList.remove('c-dark'),
    });
  });
}

/* ── SCROLL PROGRESS */
function initScrollProgress() {
  const bar = document.getElementById('sprog');
  if (!bar) return;
  lenis.on('scroll', ({ progress }) => { bar.style.width = (progress * 100).toFixed(2) + '%'; });
  ScrollTrigger.create({
    trigger: '#hero', start: 'top top', end: 'bottom top',
    onEnter:     () => { document.body.classList.add('hero-dark'); bar.style.background = 'rgba(255,255,255,.5)'; },
    onLeave:     () => { document.body.classList.remove('hero-dark'); bar.style.background = 'rgba(13,11,9,.3)'; },
    onEnterBack: () => { document.body.classList.add('hero-dark'); bar.style.background = 'rgba(255,255,255,.5)'; },
    onLeaveBack: () => { document.body.classList.remove('hero-dark'); bar.style.background = 'rgba(13,11,9,.3)'; },
  });
}

/* ── HEADER */
function initHeader() {
  const hdr = document.getElementById('hdr');
  if (!hdr) return;
  const hero = document.getElementById('hero');
  if (!hero) {
    hdr.classList.add('on');
    document.getElementById('btn-wish')?.classList.add('wish-visible');
    document.getElementById('btn-wish-m')?.classList.add('wish-visible');
    return;
  }
  ScrollTrigger.create({
    trigger: hero, start: 'top top', end: 'bottom top',
    onLeave:     () => hdr.classList.add('on'),
    onEnterBack: () => hdr.classList.remove('on'),
  });

  // Botón de lista de deseos: aparece al salir del hero
  const wishBtn  = document.getElementById('btn-wish');
  const wishBtnM = document.getElementById('btn-wish-m');
  ScrollTrigger.create({
    trigger: hero, start: 'top top', end: 'bottom top',
    onLeave:     () => { wishBtn?.classList.add('wish-visible'); wishBtnM?.classList.add('wish-visible'); },
    onEnterBack: () => { wishBtn?.classList.remove('wish-visible'); wishBtnM?.classList.remove('wish-visible'); },
  });
}

/* ── HERO ENTRANCE */
function heroEntrance() {
  gsap.timeline({ defaults: { ease: 'power4.out' } })
    .from('.hero-first-img',             { scale: 1.15, duration: 2.6, ease: 'power3.out' })
    .from('.hero-slide.active .ru',      { yPercent: 115, duration: 1.25, stagger: 0.13 }, '-=2.2')
    .from('.hero-slide.active .h-tag',   { opacity: 0, y: 12, duration: .9 }, '-=.95')
    .from('.hero-slide.active .hero-slide-foot', { opacity: 0, y: 12, duration: .75 }, '-=.75');
}

/* ── HERO MOUSE PARALLAX */
function initHeroMouseParallax() {
  const hero = document.getElementById('hero');
  if (!hero || window.matchMedia('(hover: none)').matches) return;

  hero.addEventListener('mousemove', e => {
    const img = hero.querySelector('.hero-slide.active .hero-slide-img');
    if (!img) return;
    const r = hero.getBoundingClientRect();
    const nx = (e.clientX - r.left) / r.width  - 0.5;
    const ny = (e.clientY - r.top)  / r.height - 0.5;
    gsap.to(img, { x: nx * 24, y: ny * 14, duration: 1.4, ease: 'power2.out', overwrite: 'auto' });
  });
  hero.addEventListener('mouseleave', () => {
    const img = hero.querySelector('.hero-slide.active .hero-slide-img');
    if (img) gsap.to(img, { x: 0, y: 0, duration: 2, ease: 'power3.out', overwrite: 'auto' });
  });
}

/* ── SCROLL TEXT REVEALS */
function initTextReveals() {
  gsap.utils.toArray('.ru').forEach(el => {
    if (el.closest('#hero')) return;
    gsap.from(el, {
      yPercent: 115, duration: 1.1, ease: 'power4.out',
      scrollTrigger: { trigger: el, start: 'top 88%' }
    });
  });
}

/* ── IMAGE REVEALS */
function initImgReveals() {
  gsap.utils.toArray('.card-img, .ed-img-w').forEach(wrap => {
    const img = wrap.querySelector('img');
    if (!img) return;
    const st = { trigger: wrap, start: 'top 86%' };
    gsap.from(wrap, { clipPath: 'inset(0 0 100% 0)', duration: 1.2, ease: 'power4.out', scrollTrigger: st });
    if (wrap.classList.contains('ed-img-w')) {
      gsap.from(img, { scale: 1.16, duration: 1.7, ease: 'power3.out', scrollTrigger: st });
    }
  });

  gsap.utils.toArray('.cat-item').forEach((item, i) => {
    gsap.from(item, {
      opacity: 0, y: 24, duration: .9, ease: 'power3.out',
      scrollTrigger: { trigger: item, start: 'top 88%' },
      delay: (i % 3) * 0.08
    });
  });

  gsap.utils.toArray('.ig-cell').forEach((cell, i) => {
    gsap.from(cell, {
      opacity: 0, y: 18, duration: .7, ease: 'power3.out',
      scrollTrigger: { trigger: '#ig .ig-grid', start: 'top 88%' },
      delay: (i % 6) * 0.07
    });
  });
}

/* ── PARALLAX */
function initParallax() {
  const heroImg = document.querySelector('.hero-first-img');
  if (heroImg) {
    gsap.to(heroImg, {
      yPercent: 20, ease: 'none',
      scrollTrigger: { trigger: '#hero', start: 'top top', end: 'bottom top', scrub: true }
    });
  }
  const edImg = document.querySelector('.ed-img');
  if (edImg) {
    gsap.from('.ed-img', {
      yPercent: -12, ease: 'none',
      scrollTrigger: { trigger: '#editorial', start: 'top bottom', end: 'bottom top', scrub: true }
    });
  }
}

/* ── MAGNETIC */
function initMagnetic() {
  if (window.matchMedia('(hover: none)').matches) return;
  document.querySelectorAll('.mag').forEach(el => {
    el.addEventListener('mousemove', function(e) {
      const r = this.getBoundingClientRect();
      gsap.to(this, {
        x: (e.clientX - r.left - r.width  / 2) * .3,
        y: (e.clientY - r.top  - r.height / 2) * .3,
        duration: .35, ease: 'power2.out'
      });
    });
    el.addEventListener('mouseleave', function() {
      gsap.to(this, { x: 0, y: 0, duration: .7, ease: 'elastic.out(1,.45)' });
    });
  });
}

/* ── WISHLIST */
const WISH_KEY = 'casa98_wishlist';
function getWishlist() { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); }
function saveWishlist(l) { localStorage.setItem(WISH_KEY, JSON.stringify(l)); }
function isWished(id) { return getWishlist().some(i => i.id === id); }
function toggleWish(item) {
  let l = getWishlist();
  const idx = l.findIndex(i => i.id === item.id);
  if (idx >= 0) { l.splice(idx, 1); } else { l.push(item); }
  saveWishlist(l);
  return idx < 0;
}
function updateWishBadge() {
  const n = getWishlist().length;
  ['wish-badge', 'wish-badge-m'].forEach(id => {
    const badge = document.getElementById(id);
    if (!badge) return;
    badge.textContent = n;
    badge.style.display = n > 0 ? 'flex' : 'none';
  });
}
function initWishlistBtn() {
  updateWishBadge();
  const floatBtn = document.getElementById('wishlist-btn');
  const wpp = document.getElementById('wpp-btn');
  const products = document.getElementById('products');
  const socialFloat = document.getElementById('social-float');

  function showFloats() {
    if (floatBtn) floatBtn.classList.add('visible');
    if (wpp) wpp.classList.add('visible');
    if (socialFloat) socialFloat.classList.add('visible');
  }
  function hideFloats() {
    if (floatBtn) floatBtn.classList.remove('visible');
    if (wpp) wpp.classList.remove('visible');
    if (socialFloat) socialFloat.classList.remove('visible');
  }

  lenis.on('scroll', function({ scroll }) {
    if (scroll > 120) showFloats(); else hideFloats();
  });
  document.querySelectorAll('.card[data-id]').forEach(card => {
    const btn = card.querySelector('.card-wish');
    if (!btn) return;
    const id = card.dataset.id;
    if (isWished(id)) btn.classList.add('wished');
    btn.addEventListener('click', e => {
      e.stopPropagation();
      const item = { id, name: card.dataset.name, price: card.dataset.price, img: card.dataset.img, cat: card.dataset.cat };
      const added = toggleWish(item);
      btn.classList.toggle('wished', added);
      updateWishBadge();
    });
  });
}

/* ── SEARCH */
function initSearch() {
  const overlay = document.getElementById('search-overlay');
  const panel   = document.getElementById('search-panel');
  const input   = document.getElementById('search-input');
  const closeBtn = document.getElementById('search-close');
  const openBtn  = document.querySelector('.hdr-icon[aria-label="Buscar"]');
  if (!overlay || !panel || !openBtn) return;

  let isOpen = false;

  function open() {
    if (isOpen) return;
    isOpen = true;
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    lenis.stop();
    gsap.killTweensOf([overlay, panel]);
    gsap.to(overlay, { opacity: 1, duration: .3, ease: 'power2.out' });
    gsap.fromTo(panel,
      { y: -22, scale: .97, opacity: 0 },
      { y: 0, scale: 1, opacity: 1, duration: .45, ease: 'power3.out', onComplete: () => input && input.focus() }
    );
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    document.body.style.overflow = '';
    lenis.start();
    gsap.killTweensOf([overlay, panel]);
    gsap.to(panel, { y: -14, scale: .98, opacity: 0, duration: .25, ease: 'power2.in' });
    gsap.to(overlay, {
      opacity: 0, duration: .3, ease: 'power2.in',
      onComplete: () => overlay.classList.remove('open')
    });
  }

  openBtn.addEventListener('click', open);
  closeBtn && closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', e => { if (e.target === overlay) close(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
}

boot();
